import React from 'react'
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  ApolloLink
} from '@apollo/client'
import { useKeycloak } from '@react-keycloak/web'
import { onError } from '@apollo/client/link/error'
import { Config } from '../config'
import { useWorkspace } from './workspace'
import { createUploadLink } from 'apollo-upload-client'
import { version } from '../../package.json'

export const ApolloConnectProvider: React.FC = ({ children }) => {
  const { keycloak } = useKeycloak()
  const { selectedWorkspace } = useWorkspace(({ selectedWorkspace }) => ({
    selectedWorkspace
  }))

  const token = keycloak?.token

  const httpLink = createUploadLink({
    uri: Config.backEndUrl,
    headers: {
      'Accept-Language': 'pt-BR',
      'Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
      'App-Client-Name': 'client-phaco',
      'App-Client-Version': version,
      authorization: `Bearer ${token}`,
      ...(selectedWorkspace
        ? { 'X-Workspace': selectedWorkspace?._id || '' }
        : {})
    }
  })

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.map(({ message, extensions }) => {
        console.error(extensions)
        return console.error(message)
      })
    }
    if (networkError) {
      console.log(`[Network error]: ${networkError}`)
    }
  })

  console.log('CONNECT_APOLLO')

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    link: ApolloLink.from([errorLink, httpLink as any])
  })

  return <ApolloProvider client={client}>{children}</ApolloProvider>
}
